import { userDb } from '../config/pouch';
import { hashPassword } from './passwordHash';

// Normalise l'argument en email (accepte une chaîne ou un objet utilisateur Firebase).
const resolveEmail = (emailOrUser) => {
    if (!emailOrUser) return '';
    if (typeof emailOrUser === 'string') return emailOrUser.toLowerCase();
    if (typeof emailOrUser.email === 'string') return emailOrUser.email.toLowerCase();
    return '';
};

export const saveUserLocally = async (email, password = null) => {
    const id = resolveEmail(email);
    if (!id) {
        throw new Error('Email requis pour la sauvegarde locale');
    }

    try {
        let existingDoc = null;
        try {
            existingDoc = await userDb.get(id);
        } catch (err) {
            if (err.status !== 404) {
                throw err;
            }
        }

        // Le mot de passe n'est jamais stocké en clair : seul un hash PBKDF2 est
        // conservé. Sans mot de passe fourni, on préserve le hash existant.
        let passwordHash = existingDoc ? existingDoc.passwordHash || null : null;
        if (password) {
            passwordHash = await hashPassword(password);
        }

        const userDoc = {
            ...(existingDoc || {}),
            _id: id,
            email: id,
            passwordHash,
            lastAccess: new Date().toISOString()
        };
        // Supprimer tout ancien champ mot de passe en clair éventuellement présent.
        delete userDoc.password;

        await userDb.put(userDoc);

        // Sauvegarder dans localStorage pour une récupération rapide
        localStorage.setItem('lastLoggedUser', JSON.stringify({
            email: id,
            timestamp: Date.now()
        }));

        return true;
    } catch (error) {
        throw error;
    }
};
